import { logError } from '@databases/logs';

import { APP_MODE, isEmbed, isStandalone } from '../utils';

const standaloneBridgeApi = new Promise<DatabaseBridgeAPI>((resolve) => {
  if (globalThis.window.databaseBridge) {
    resolve(globalThis.window.databaseBridge);
  } else {
    globalThis.window.addEventListener('load', () => {
      if (globalThis.window.databaseBridge) {
        resolve(globalThis.window.databaseBridge);
      }
    });

    globalThis.window.addEventListener('message', (e) => {
      if (e.source === globalThis.window.parent) {
        const data = e.data;
        if (data && data.type === 'bridge-ready') {
          if (!globalThis.window.databaseBridge) {
            throw new Error('bridge marked as ready but no bridge exists');
          }

          resolve(globalThis.window.databaseBridge);
        }
      }
    });
  }
});

export const getBridgeAPI = (): Promise<DatabaseBridgeAPI> => {
  if (isStandalone()) {
    return standaloneBridgeApi;
  } else if (isEmbed()) {
    return Promise.resolve({
      onboardingService: {
        onOnboardingChange: () => {},
      },
      updateBoardStatus: () => {},
      updateMoreActions: () => {},
      onContentLoadSucceeded: () => {},
      onContentLoadFailed: () => {},
    });
  } else {
    const error = new Error('Bridge is not available in current mode: ' + APP_MODE);
    logError(error);
    throw error;
  }
};

export interface Item {
  id: string;
  text: string;
  shortcutText?: string;
  isDisabled?: boolean;
  showToggle?: {
    isDisabled: boolean;
    isChecked: boolean;
  };
  onClick?: (e: any) => void;
  url?: string;
  target?: string;
}

export interface ItemGroup {
  id: string;
  items: Item[];
  text?: string;
}

export interface MoreActions {
  items: (Item | ItemGroup)[][];
}

export interface DatabaseBridgeAPI {
  onboardingService?: DatabaseOnboardingService;
  updateBoardStatus: (data: { status: string; tooltipText: string | undefined }) => void;
  updateMoreActions?: (items: MoreActions) => void;
  onContentLoadSucceeded: (attributes: any) => void;
  onContentLoadFailed: (error: any, attributes: any) => void;
}

export interface DatabaseSessionData {
  userId: string;
}

interface DatabaseOnboardingService {
  onOnboardingChange?: (screen: string) => void;
}

declare global {
  interface Window {
    databaseBridge: DatabaseBridgeAPI;
  }
}
